import React, { useEffect } from "react";
import Header from "../header";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { useStyles } from "./indexStyles";
import { getRoute } from "../../helpers/utils";
import { getWebService } from "../../helpers/server";

function MainLayout({ children, ...rest }) {
  const {
    classes: { buyflowContainer },
  } = rest;
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    async function verifyToken() {
      try {
        const response = await getWebService("verifytoken.php");

        const { code = 200 } = response.data;
        if (code === 401) {
          navigateTo(getRoute("home"));
        }
      } catch (error) {
        // console.log(error);
      }
    }

    if ([getRoute("home")].indexOf(pathname) === -1) {
      verifyToken();
    }
  }, [pathname, history]);

  const navigateTo = (pathname) => history.push({ pathname });

  return (
    <Box className={buyflowContainer}>
      <Header onClick={() => {}} title={""} isBackButtonVisible={false} />
      {children}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(MainLayout);
